(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Conditional field visibility for mega menu blocks
  document.addEventListener('DOMContentLoaded', function() {
    // Function to toggle field visibility based on column type
    function toggleFieldsVisibility() {
      const blocks = document.querySelectorAll('[data-block-type="child"]');
      
      blocks.forEach(block => {
        const columnTypeSelect = block.querySelector('select[name*="column_type"]');
        if (!columnTypeSelect) return;
        
        const titleField = block.querySelector('[data-setting="title"]') || block.querySelector('input[name*="title"]');
        const contentField = block.querySelector('[data-setting="content"]') || block.querySelector('textarea[name*="content"]');
        const themeField = block.querySelector('[data-setting="theme"]') || block.querySelector('select[name*="theme"]');
        const imageField = block.querySelector('[data-setting="image"]') || block.querySelector('input[name*="image"]');
        const imageLinkField = block.querySelector('[data-setting="image_link"]') || block.querySelector('input[name*="image_link"]');
        
        function updateVisibility() {
          const columnType = columnTypeSelect.value;
          
          // Show/hide fields based on column type
          if (columnType === 'links') {
            if (titleField) titleField.closest('.field')?.style.setProperty('display', 'block');
            if (contentField) contentField.closest('.field')?.style.setProperty('display', 'block');
            if (themeField) themeField.closest('.field')?.style.setProperty('display', 'block');
            if (imageField) imageField.closest('.field')?.style.setProperty('display', 'none');
            if (imageLinkField) imageLinkField.closest('.field')?.style.setProperty('display', 'none');
          } else if (columnType === 'image') {
            if (titleField) titleField.closest('.field')?.style.setProperty('display', 'none');
            if (contentField) contentField.closest('.field')?.style.setProperty('display', 'none');
            if (themeField) themeField.closest('.field')?.style.setProperty('display', 'none');
            if (imageField) imageField.closest('.field')?.style.setProperty('display', 'block');
            if (imageLinkField) imageLinkField.closest('.field')?.style.setProperty('display', 'block');
          }
        }
        
        // Initial visibility update
        updateVisibility();
        
        // Listen for changes
        columnTypeSelect.addEventListener('change', updateVisibility);
      });
    }
    
    // Run on page load
    toggleFieldsVisibility();
    
    // Run when new blocks are added
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList?.contains('block') || node.querySelector?.('.block'))) {
              setTimeout(toggleFieldsVisibility, 100);
            }
          });
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
